import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Button} from 'semantic-ui-react';
import {Actions} from '../../../../common/actions';

class SaveButton extends Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    const {detail, agency, dealer} = this.props;

    if (!detail.length) {
      this.props.addMessageBoxWarning('No se puede guardar órdenes de devolución vacías.');
      return;
    }

    this.props.createPartsReturnOrder({dealer, agency, detail});
  }

  render() {
    const {returnOrder, creating} = this.props;

    if (returnOrder) {
      return null;
    }

    return (
      <Button primary content='GUARDAR' disabled={creating} onClick={this.handleClick} />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'dealer': state.session.dealerId,
    'agency': state.session.dealerAgency,
    'detail': state.partsReturnsOrders.orderDetail,
    'returnOrder': state.partsReturnsOrders.selectedOrder,
    'creating': state.partsReturnsOrders.creating,
  };
};

const {
  createPartsReturnOrder,
  addMessageBoxWarning,
} = Actions;

export default connect(mapStateToProps, {
  createPartsReturnOrder,
  addMessageBoxWarning,
})(SaveButton);
